import gql from 'graphql-tag';

import { CommentFragment } from '../fragments';

export const UpdateCommentReply_Mutation = gql`
    mutation UpdateCommentReplyMutation(
        $input: UpdateCommentReplyInput!
    ) {
        updateCommentReply(
            input: $input
        ) {
            comment {
                ...CommentFragment
            }
        }
    }
    ${CommentFragment}
`;
